import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, MotionConfig, useReducedMotion } from 'motion/react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Resources from './pages/Resources';
import Mockups from './pages/Mockups';
import Referral from './pages/Referral';
import TreatmentPage from './pages/treatments/TreatmentPage';
import SmileGallery from './pages/SmileGallery';
import FeesPlans from './pages/FeesPlans';
import CBCTReferral from './pages/referral/CBCT';
import ImplantsReferral from './pages/referral/Implants';
import ExtractionsReferral from './pages/referral/Extractions';
import EndodonticsReferral from './pages/referral/Endodontics';
import OrthodonticsReferral from './pages/referral/Orthodontics';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import FloatingBookButton from './components/FloatingBookButton';
import { BASE_PATH } from './version';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<TreatmentPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/referral" element={<Referral />} />
        <Route path="/smile-gallery" element={<SmileGallery />} />
        <Route path="/fees-plans" element={<FeesPlans />} />
        <Route path="/referral/cbct" element={<CBCTReferral />} />
        <Route path="/referral/dental-implants" element={<ImplantsReferral />} />
        <Route path="/referral/extractions" element={<ExtractionsReferral />} />
        <Route path="/referral/endodontics" element={<EndodonticsReferral />} />
        <Route path="/referral/orthodontics" element={<OrthodonticsReferral />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
    </AnimatePresence>
  );
}

function AppLayout() {
  const { pathname } = useLocation();
  if (pathname === '/mockups') {
    return (
      <Routes>
        <Route path="/mockups" element={<Mockups />} />
      </Routes>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <a href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-gold focus:text-forest focus:rounded-lg focus:font-semibold focus:shadow-lg">
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content" className="flex-1">
        <AnimatedRoutes />
      </main>
      <Footer />
      <FloatingBookButton />
    </div>
  );
}

function MotionWrapper({ children }) {
  const prefersReduced = useReducedMotion();
  return (
    <MotionConfig reducedMotion={prefersReduced ? 'always' : 'never'}>
      {children}
    </MotionConfig>
  );
}

export default function App() {
  return (
    <BrowserRouter basename={BASE_PATH}>
      <MotionWrapper>
        <ScrollToTop />
        <AppLayout />
      </MotionWrapper>
    </BrowserRouter>
  );
}
